
const DOUBLE_CLICK_INTERVAL_MS = 500;
let nextClickIsADoubleClick = false;
export function captureDoubleClickAndCall(evt, callback: () => void) {
  if (nextClickIsADoubleClick) {
    evt.stopPropagation()
    callback();
    return;
  }

  // Do not stop propagation if it's the first click.
  nextClickIsADoubleClick = true;
  setTimeout(
    () => (nextClickIsADoubleClick = false),
    DOUBLE_CLICK_INTERVAL_MS,
  );
}

export function outclick(node: HTMLElement, callback: (clickEvent) => void) {
  const handleClick = (clickEvent: PointerEvent) => {
    // For accessibility reasons, the click event also triggers when we press spacebar, 
    // because we may want to focus on a differnt thing.
    //
    // These events have no coordinates, so we use that to ignore them.
    if (clickEvent.x === 0 && clickEvent.y === 0) {
      return
    }
    if (!node.contains(<Node>clickEvent.target)) {
      callback(clickEvent)
    }
  };

  document.addEventListener('click', handleClick, true);

  return {
    destroy() {
      document.removeEventListener('click', handleClick, true);
    },
  };
}